module.exports = __webpack_public_path__ + "media/entities/2002-27028383.png";